/**
 * Section — consistent vertical rhythm & max width container.
 */
export default function Section({
  id,
  children,
  className = "",
  containerClassName = "",
  bg = "white",
  testId,
}) {
  const bgClass =
    bg === "muted"
      ? "bg-[#F9FAFB]"
      : bg === "brand-subtle"
      ? "bg-[#ECFDF5]"
      : "bg-white";
  return (
    <section
      id={id}
      data-testid={testId}
      className={`${bgClass} ${className}`}
    >
      <div
        className={`max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28 ${containerClassName}`}
      >
        {children}
      </div>
    </section>
  );
}
